import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Motion, spring } from 'react-motion';
import Image from 'next/image';
import PcModelStatTip from 'containers/PcModel/PcModelStatTip';
import { useState } from 'react';
import styles from './styles';

const ProgressBar = ({
  value,
  min,
  max,
  target,
  customizedProgress,
  customizedProgressBar,
  thick,
  parameter,
}) => {
  const progress = ((value - min) / (max - min)) * 100;

  const [isTipOpen, setIsTipOpen] = useState(false);

  const handleCloseTip = () => {
    setIsTipOpen(false);
  };

  const handleOpenTip = () => {
    setIsTipOpen(true);
  };

  if (!target) {
    return (
      <Motion style={{ x: spring(progress) }}>
        {({ x }) => (
          <div
            className={classNames(
              `${customizedProgressBar || 'progress-bar'}`,
              { 'thick-bar': thick },
            )}
          >
            <div
              className={`${customizedProgress || 'progress'}`}
              style={{ width: `${x}%` }}
            />
            <style jsx>{styles}</style>
          </div>
        )}
      </Motion>
    );
  }

  const isUnderTarget = value < target;
  const targetProgress = ((target - min) / (max - min)) * 100;

  if (isUnderTarget) {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="bar-container" onClick={handleOpenTip}>
        <Motion style={{ x: spring(progress), y: spring(targetProgress) }}>
          {({ x, y }) => (
            <div
              className={classNames(
                `${customizedProgressBar || 'progress-bar'}`,
                'progress-bar-under',
                'progress-bar-width',
                { 'thick-bar': thick },
              )}
            >
              <div className="progress under" style={{ width: `${x}%` }} />
              <div
                className={classNames('target', { 'thick-target': thick })}
                style={{ left: `${y}%` }}
              />
              <div className="performance-icon">
                <button type="button" onClick={handleOpenTip}>
                  <Image draggable={false}
                    src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-falls-short.svg?v=1714038189"
                    alt="Performance Falls Short"
                    width={20}
                    height={20}
                  />
                </button>
                <PcModelStatTip
                  type="under"
                  handleCloseModal={handleCloseTip}
                  isTooltipOpen={isTipOpen}
                  parameter={parameter}
                />
              </div>
              <style jsx>{styles}</style>
            </div>
          )}
        </Motion>
        {/* <div>U</div> */}
      </div>
    );
  }

  const over = value - target;
  const overProgress = ((over - min) / (max - min)) * 100;

  return (
    <div className="bar-container" onClick={handleOpenTip}>
      <Motion style={{ x: spring(targetProgress), y: spring(overProgress) }}>
        {({ x, y }) => (
          <div
            className={classNames(
              `${customizedProgressBar || 'progress-bar'}`,
              'progress-bar-over',
              'progress-bar-width',
              { 'thick-bar': thick },
            )}
          >
            <div className="progress" style={{ width: `${x}%` }} />
            <div className="progress over" style={{ width: `${y}%` }} />
            <div
              className={classNames('target', { 'thick-target': thick })}
              style={{ left: `${x}%` }}
            />
            {value === target && (
              <div className="performance-icon">
                <button type="button" onClick={handleOpenTip}>
                  <Image draggable={false}
                    src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-meets.svg?v=1714038225"
                    alt="Performance Meets"
                    width={20}
                    height={20}
                  />
                </button>
                <PcModelStatTip
                  type="meets"
                  handleCloseModal={handleCloseTip}
                  isTooltipOpen={isTipOpen}
                  parameter={parameter}
                />
              </div>
            )}
            {value > target && (
              <div className="performance-icon">
                <button type="button" onClick={handleOpenTip}>
                  <Image draggable={false}
                    src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/icon-exceeds.svg?v=1714038244"
                    alt="Performance Exceeded"
                    width={20}
                    height={20}
                  />
                </button>
                <PcModelStatTip
                  type="over"
                  handleCloseModal={handleCloseTip}
                  isTooltipOpen={isTipOpen}
                  parameter={parameter}
                />
              </div>
            )}

            <style jsx>{styles}</style>
          </div>
        )}
      </Motion>
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  target: PropTypes.number,
  customizedProgress: PropTypes.string,
  customizedProgressBar: PropTypes.string,
  thick: PropTypes.bool,
  parameter: PropTypes.string,
};

ProgressBar.defaultProps = {
  min: 0,
  max: 20,
  target: undefined,
  customizedProgress: null,
  customizedProgressBar: null,
  thick: false,
  parameter: null,
};

export default ProgressBar;
